// extracted by mini-css-extract-plugin
export default {"header":"XOner","inner":"_nzyH","icon":"s7L8v","label":"p416h","text":"bVsee","triggerIcon":"_2zBO"};